import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import styles from "../../table/tableStyles";
import "./Theme3Table.scss";

const SubsidizedPricesAsShareOfNonSubsidizedPriceTable = ({ na, classes }) => (
  <div className={classes.container}>
    <table className={classNames("Theme3Table", classes.table)}>
      <thead>
        <tr className={classes.heading}>
          <td />
          <td className={classes.center}>Implant</td>
          <td className={classes.center}>IUD</td>
          <td className={classes.center}>Injection</td>
          <td className={classes.center}>Pill</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Asia</td>
          <td className={classes.right}>2%</td>
          <td className={classes.right}>4%</td>
          <td className={classes.right}>31%</td>
          <td className={classes.right}>2%</td>
        </tr>
        <tr className={classes.row}>
          <td>Europe</td>
          <td className={classes.center}>{na}</td>
          <td className={classes.center}>{na}</td>
          <td className={classes.center}>{na}</td>
          <td className={classes.center}>{na}</td>
        </tr>
        <tr className={classes.row}>
          <td>Africa</td>
          <td className={classes.right}>29%</td>
          <td className={classes.right}>6%</td>
          <td className={classes.right}>64%</td>
          <td className={classes.right}>23%</td>
        </tr>
        <tr className={classes.row}>
          <td>Americas</td>
          <td className={classes.right}>2%</td>
          <td className={classes.center}>{na}</td>
          <td className={classes.right}>11%</td>
          <td className={classes.center}>{na}</td>
        </tr>
        <tr className={classes.totalRow}>
          <td>Total</td>
          <td className={classes.right}>12%</td>
          <td className={classes.right}>3%</td>
          <td className={classes.right}>31%</td>
          <td className={classes.right}>4%</td>
        </tr>
      </tbody>
    </table>
  </div>
);

SubsidizedPricesAsShareOfNonSubsidizedPriceTable.propTypes = {
  na: PropTypes.string
};

SubsidizedPricesAsShareOfNonSubsidizedPriceTable.defaultProps = {
  na: "n/a"
};

export default memo(
  withStyles(styles)(SubsidizedPricesAsShareOfNonSubsidizedPriceTable)
);
